import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class DocumentsTreeClaimDetailItem extends BaseModel {
    @Expose() id = 0;
    @Expose() category = "";
    @Expose() coverageIds = "";
    @Expose() title = "";
    @Expose() description = "";
    @Expose() noDeclared = false;
    @Expose() modal = "";
    @Expose() required = false;
    @Expose() assetId = "";
}
